/* eslint-disable quote-props */
import apiRoutes from 'core/apiRoutes';

export default {
  ...apiRoutes,

  // Browser
  'django-admin': '/secret/',
  account: '/account/',
  logout: '/account/logout/',
  'school-by-year': '/account/school/:year/',
  school: '/account/school/',
  'classes-by-year': '/account/classes/:year/',
  classes: '/account/classes/',
  profile: '/account/profile/',
  'class-editor': '/class-management/my-school/',

  // School Dashboard
  'school-dashboard': '/school/:schoolSlug/',
  'school-dashboard-exam': '/school/:schoolSlug/exam/:examId/',
  'school-dashboard-exam-by-year': '/school/:schoolSlug/:year/exam/:examId/',

  // Public school uploader
  'class-list-uploader': '/class-list-uploader/',

  // Exam/Topic Grids
  'course-exam-grid': '/class/:classId/progress/exam/:examId/', // 'class_progress_grid'
  'topic-grid': '/class/:classId/progress/topic/:topicId/', // 'class_progress_grid'
  'topic-exam-grid': '/class/:classId/progress/topic/:topicId/exam/:examId/', // 'class_progress_grid'

  // Teacher Dashboards
  'class-lesson-insights-page':
    '/class/:classId/topic/:topicId/dashboards/lesson/:lessonId/',

  // Senior Insights
  'em-insights-page':
    '/class/:classId/topic/:topicId/exam/:examId/em-insights/',

  // Student Progress (Lesson Grid)
  'class-lesson-grid': '/class/:classId/progress/lesson/:lessonId/',

  // Individual Student Course Progress
  'student-course-progress': '/class/:classId/progress/student/:profileId/',

  // Student Notes Notebook
  'student-notes-notebook':
    '/class/:classId/lesson/:lessonId/notes/:profileId/',

  // Course Navigation
  'courses-page': '/courses/',
  'library-page': '/library/',
  'course-page': '/class/:classId/course/',
  'topic-page': '/class/:classId/course/:topicId/',
  'library-access': '/library/access/:courseId/',

  // Task Setting
  'tasks-page': '/tasks/',
  'task-page': '/tasks/:taskId/',
  'task-item-page': '/tasks/:taskId/task-items/:taskItemId/',
  'task-insights-page': '/tasks/:taskId/insights/',
  'task-question-insights-page': '/tasks/:taskId/insights/:questionId', // TODO: /insights/task/:taskId/question/:questionId

  course: '/course/:courseId/', // TBC: redirects to course page?

  // Lesson Questions
  'question-set-index': '/class/:classId/question-set/:examId/',
  'question-set-question':
    '/class/:classId/question-set/:examId/question/:questionId/',

  'question-set-grid': '/class/:classId/progress/question-set/:examId/',
  'reflective-question-set-grid':
    '/class/:classId/progress/reflective-question-set/:examId/', // TODO: temporary
  'question-set-question-review':
    '/class/:classId/progress/question-set/:examId/question/:questionId/',

  // Exams
  exams: '/exams/:examId/',
  'exams-print': '/exams/:examId/print/',
  'exams-solutions-print': '/exams/:examId/solutions/print/#preview',
  'exams-mistakes': '/exams/:examId/mistakes/',
  'exams-mistakes-question': '/exams/:examId/mistakes/:questionId/',
  'exams-mistakes-question-solution':
    '/exams/:examId/mistakes/:questionId/solution/',
  'exams-section': '/exams/:examId/:sectionId/',
  'exams-transcribe': '/exams/:examId/transcribe/:sectionId/',
  'exams-section-solution': '/exams/:examId/:sectionId/solution/',
  'exams-section-transcribe': '/exams/:examId/transcribe/:sectionId/',
  'em-question-review':
    '/class/:classId/topic/:topicId/progress/em/:examId/question/:questionId/',

  // Exam Marking
  'class-exam-marking': '/class/:classId/progress/exam/:examId/mark/',
  'class-exam-marking-question':
    '/class/:classId/progress/exam/:examId/mark/question/:questionId/',

  // Payments
  payment: '/payment/',
  'payment-by-code': '/payment/:code/',

  // Fulfilment
  fulfilment: '/fulfilment/',
  'fulfilment-by-code': '/fulfilment/?paymentLinkCode=:code',

  // Chunkview
  chunkview: '/class/:classId/lesson/',
  'chunkview-lesson': '/class/:classId/lesson/:lessonId/',
  'chunkview-chunk': '/class/:classId/lesson/:lessonId/:index/',

  // Content admin
  'content:lesson-edit': '/content/admin/lessons/edit/:id/',

  // Demo
  'demo-question-set-index': '/demo/question-set/:examId/',
  'demo-question-set-question':
    '/demo/question-set/:examId/question/:questionId/',
  'demo-chunkview-lesson': '/demo/lesson/:lessonId/',
  'demo-chunkview-chunk': '/demo/lesson/:lessonId/:index/',
};
